import { Shield01 } from '@untitled-ui/icons-react';
import clsx from 'clsx';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './style.module.scss';

interface DraftPromptBarProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

// A slim context bar under the panel header (Customer Support / agent mode only).
// When on, the whole bar shifts to a caution treatment so a draft-prompt session
// is unmistakable. Just the toggle — no draft picker (a single draft, server-side
// drafts don't exist yet: AID-233).
export const DraftPromptBar: FC<DraftPromptBarProps> = ({
  checked,
  onChange,
}) => {
  const { t } = useTranslation('common');

  return (
    <label
      className={clsx(
        styles.draftPromptBar,
        checked && styles.draftPromptBarOn
      )}
    >
      <span className={styles.draftPromptIcon} aria-hidden={'true'}>
        <Shield01 />
      </span>
      <span className={styles.draftPromptCopy}>
        <b>
          {checked
            ? t('chat.draftPrompt.titleActive')
            : t('chat.draftPrompt.title')}
        </b>
        <span>
          {checked
            ? t('chat.draftPrompt.subtitleActive')
            : t('chat.draftPrompt.subtitle')}
        </span>
      </span>
      <span className={styles.draftPromptSwitch}>
        <input
          type={'checkbox'}
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          aria-label={t('chat.draftPrompt.title')}
        />
        <span className={styles.draftPromptTrack} />
        <span className={styles.draftPromptKnob} />
      </span>
    </label>
  );
};
